import type { Country } from '@Types/country';

export const enrichCountryObject = (countryObject?: Country) => {
  return countryObject
    ? {
        ...countryObject,
        title: countryObject.name,
        value: countryObject.code,
      }
    : undefined;
};

export const findCountry = (
  countries: Country[] | undefined,
  searchCountry: string | undefined
) => {
  return countries?.find((item: Country) => item.code === searchCountry);
};

export const extractStatesFromCountry = (country: Country | undefined) => {
  return country?.subDivisions?.map((subDivision) => ({
    title: subDivision.name,
    value: subDivision.code,
  }));
};
